import type { ViewMode } from '@atlassian/jira-portfolio-3-common';
import {
	getIsPlanInfoReady,
	isExportMode,
	isConfluenceMacro,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import {
	getDateConfiguration,
	type DateConfiguration,
	getPlanningUnit,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getViewMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import { getNamespaceFromActiveView } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/views';
import { getMatchingConfiguredDate } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/fields/utils';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

const query = createSelector(
	[
		getDateConfiguration,
		getIsPlanInfoReady,
		getNamespaceFromActiveView,
		getPlanningUnit,
		getViewMode,
		isExportMode,
		isConfluenceMacro,
	],
	(
		dateConfiguration: DateConfiguration,
		isPlanInfoReady: boolean,
		viewNamespace: string,
		planningUnit: string,
		viewMode: ViewMode,
		// eslint-disable-next-line @typescript-eslint/no-shadow
		isExportMode: boolean,
		// eslint-disable-next-line @typescript-eslint/no-shadow
		isConfluenceMacro: boolean,
	) => ({
		getMatchingConfiguredDate: getMatchingConfiguredDate(dateConfiguration),
		areCustomFieldsReady: isPlanInfoReady,
		viewNamespace,
		planningUnit,
		viewMode,
		isExportMode,
		isConfluenceMacro,
	}),
);

export default query;
